window.app_models.option = {
    id:null,
    name:null
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/option.js